import { ErrorHandler, Injectable, inject, NgZone } from '@angular/core';
import { ToastService } from '@core/services/toast.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly zone = inject(NgZone);
  private readonly toast = inject(ToastService);

  handleError(error: unknown): void {
    const message = this.extractMessage(error);

    this.zone.run(() => {
      if (this.isChunkLoadError(error)) {
        this.toast.warning('Nova versão disponível. A página será recarregada.', { duration: 3000 });
        setTimeout(() => window.location.reload(), 3000);
        return;
      }

      this.toast.error(message);
    });

    console.error('[NEXUS Error]', error);
  }

  private extractMessage(error: unknown): string {
    if (error instanceof Error) {
      if (error.message.includes('Http failure response')) {
        return 'Erro de comunicação com o servidor. Tente novamente.';
      }
      return error.message;
    }
    return 'Ocorreu um erro inesperado. Tente novamente.';
  }

  private isChunkLoadError(error: unknown): boolean {
    return error instanceof Error && (
      error.message.includes('Loading chunk') ||
      error.message.includes('ChunkLoadError')
    );
  }
}
